module.exports = __webpack_public_path__ + "img/egypt.6143003e.svg";